import { Check, Loader2 } from "lucide-react";
import {
  checklistItems,
  checklistSummary,
  type SetupConditions,
} from "@/lib/setup-progress";
import { cn } from "@/lib/utils";

// A Boo's setup as a checklist, from the conditions the backend reports.
// Renders nothing for a Boo without conditions (one on Railway).
export function SetupChecklist({
  conditions,
  showDetails = false,
}: {
  conditions?: SetupConditions;
  showDetails?: boolean;
}) {
  const steps = checklistItems(conditions, showDetails);
  if (!steps) return null;
  return (
    <div>
      <p className="sr-only" aria-live="polite">
        {checklistSummary(steps)}
      </p>
      <ol
        className="flex flex-col gap-2 text-left text-sm"
        aria-label="Setup progress"
      >
        {steps.map((step) => (
          <li key={step.name} className="flex items-start gap-3">
            <span
              className="mt-0.5 flex size-4 shrink-0 items-center justify-center"
              aria-hidden
            >
              {step.state === "done" ? (
                <Check className="size-4 text-emerald-600 dark:text-emerald-400" />
              ) : step.state === "current" ? (
                <Loader2 className="size-4 animate-spin text-muted-foreground" />
              ) : (
                <span className="size-1.5 rounded-full bg-muted-foreground/40" />
              )}
            </span>
            <span className="flex flex-col">
              <span
                className={cn(
                  step.state === "waiting" && "text-muted-foreground",
                  step.state === "current" && "font-medium",
                )}
              >
                {step.label}
                <span className="sr-only">
                  {step.state === "done"
                    ? " (done)"
                    : step.state === "current"
                      ? " (in progress)"
                      : " (waiting)"}
                </span>
              </span>
              {step.detail && (
                <span className="text-xs text-muted-foreground font-mono">
                  {step.detail}
                </span>
              )}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
